import type { ItemDetailDto } from '@bnn/shared';
import { Link, useParams } from 'react-router-dom';
import { Alert, Badge, Card, Empty, PageHeader, Spinner, Table } from '../components/ui';
import { useApi } from '../lib/useApi';

export default function ItemDetailPage() {
  const { code = '' } = useParams();
  const { data: item, error, loading } = useApi<ItemDetailDto>(`/items/${encodeURIComponent(code)}`);

  if (loading && !item) return <Spinner />;
  if (error) return <Alert>{error.message}</Alert>;
  if (!item) return null;

  return (
    <>
      <Link to="/items" className="text-sm text-brand hover:underline">
        ← สินค้า
      </Link>
      <PageHeader
        title={item.item_code}
        subtitle={
          <>
            {item.item_name} · กลุ่ม {item.item_group ?? '-'} · UoM Group {item.uom_group_code ?? 'ไม่มี (นับได้เฉพาะ Inventory UoM)'}{' '}
            {!item.countable ? <Badge tone="warn">ไม่ใช่สินค้าคงคลัง — นับไม่ได้</Badge> : !item.is_active && <Badge tone="warn">Inactive ใน SAP — นับได้ ตรวจสอบกับทีม Cost</Badge>}
          </>
        }
      />
      <div className="grid gap-4 lg:grid-cols-[3fr_2fr]">
        <Card title={`หน่วยที่นับได้ (${item.uoms.length})`}>
          <p className="mb-2 text-sm text-muted">ระบบแปลงยอดที่นับเป็น Inventory UoM ({item.inventory_uom}) ให้อัตโนมัติด้วยอัตรานี้</p>
          <Table head={['หน่วย', 'ชื่อ', `1 หน่วย = ? ${item.inventory_uom}`, '']} minWidth={420}>
            {item.uoms.map((u) => (
              <tr key={u.uom_code}>
                <td className="font-medium">{u.uom_code}</td>
                <td className="text-muted">{u.uom_name}</td>
                <td className="font-mono">{u.factor}</td>
                <td className="space-x-1 whitespace-nowrap">
                  {u.is_inventory && <Badge tone="brand">Inventory</Badge>}
                  {u.preferred && <Badge tone="ok">ใช้บ่อย</Badge>}
                </td>
              </tr>
            ))}
          </Table>
        </Card>
        <Card title={`Barcode (${item.barcodes.length})`}>
          {item.barcodes.length === 0 ? (
            <Empty>ยังไม่มี Barcode — บันทึกได้ที่หน้านับ หน้า Barcode หรือ Import ไฟล์ Barcode</Empty>
          ) : (
            <ul className="divide-y divide-line">
              {item.barcodes.map((b) => (
                <li key={b.id} className="py-2">
                  <div className="font-mono font-semibold">{b.barcode}</div>
                  <div className="text-sm text-muted">
                    {b.uom_code} · {b.barcode_type}
                    {b.supplier && ` · ${b.supplier}`} {!b.is_active && <Badge>Inactive</Badge>}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </Card>
      </div>
    </>
  );
}
